import { render, staticRenderFns } from "./DialogLandLordsContentLegalExpenses.vue?vue&type=template&id=4fe034b6&"
import script from "./DialogLandLordsContentLegalExpenses.vue?vue&type=script&lang=js&"
export * from "./DialogLandLordsContentLegalExpenses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports